import { MergeFormConfig } from "@/types/merge";
import { Company } from "@/components/CompanyCard";


export const companyMergeConfig: MergeFormConfig<Company> = {
	entityName: "companies",
	excludeFields: ["id", "jobCount", "is_dummy_data"],
	fields: [
		{
			name: "name",
			type: "text",
			label: "Company Name",
			mergeBehavior: "manual",
			required: true,
			description: "Company name"
		},
		{
			name: "logo_url",
			type: "text",
			label: "Logo URL",
			mergeBehavior: "manual",
			description: "Company logo URL"
		},
		{
			name: "street",
			type: "text",
			label: "Street",
			mergeBehavior: "manual",
			description: "Street address"
		},
		{
			name: "postal_code",
			type: "text",
			label: "Postal Code",
			mergeBehavior: "manual",
			description: "Postal code"
		},
		{
			name: "city",
			type: "text",
			label: "City",
			mergeBehavior: "manual",
			description: "City"
		},
		{
			name: "country",
			type: "text",
			label: "Country",
			mergeBehavior: "manual",
			description: "Country"
		},
		{
			name: "vat_number",
			type: "text",
			label: "VAT Number",
			mergeBehavior: "manual",
			description: "VAT number"
		},
		{
			name: "website_url",
			type: "text",
			label: "Company URL",
			mergeBehavior: "manual",
			description: "Company website URL"
		},
		{
			name: "assignee",
			type: "text",
			label: "Assignee",
			mergeBehavior: "manual",
			description: "Company assignee"
		}
	]
};
